import React, { useState, useEffect, Fragment } from 'react';
import styles from '../../assets/css/module/common.module.css';
import { IsNotNull, notifBeforeAct, checkApproveResult, checkRejectResult, openFileNewTab } from '../../helpers/helper';
import { enqueueSnackbar } from 'notistack';
import { useParams } from 'react-router-dom';
import ModalDetail from './leave-request-detail'
import dayjs from 'dayjs';
import { EyeFill, ClockHistory, CheckCircleFill, XCircleFill, Paperclip } from 'react-bootstrap-icons';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import { getBlobS3 } from '../../controllers/s3/s3';

const LeaveController = require('../../controllers/employee/permissions/leave');

const CFLDashboard = () => {
  let { p1 } = useParams();
  const [objDetail, setObjDetail] = useState(null)
  const [responseNotes, setResponseNotes] = useState('')
  const [disableActionButton, setDisableActionButton] = useState(false)
  const [modalDetail, setModalDetail] = useState(false)
  const [leaveTypeData, setLeaveTypeData] = useState([])

  const toogleDetail = () => {
    setModalDetail(!modalDetail)
  }

  async function getDataLeaveRequest() {
    let b = { p1: p1 }
    LeaveController.getLeaveRequest(b).then(x => {
      setObjDetail(x[0])
    })
  }

  useEffect(() => {
    if (IsNotNull(p1)) {
      getDataLeaveRequest()
      getLeaveTypeData()
    }
  }, [p1])

  function getStatusComponent() {
    let status = 'Belum Diproses'
    let badgeClass = 'modern-badge-pending'
    let Icon = ClockHistory

    if (IsNotNull(objDetail)) {
      switch (objDetail.l_status) {
        case 2:
          status = 'Disetujui'
          badgeClass = 'modern-badge-approved'
          Icon = CheckCircleFill
          break;
        case 3:
          status = 'Ditolak'
          badgeClass = 'modern-badge-rejected'
          Icon = XCircleFill
          break;
        default:
          break;
      }
    }

    return (
      <div className={`${styles['modern-badge']} ${styles[badgeClass]}`}>
        <Icon size={11} />
        {status}
      </div>
    )
  }

  async function approveSuccess() {
    getDataLeaveRequest()
  }

  async function rejectSuccess() {
    getDataLeaveRequest()
  }

  async function Approve(e) {
    if (IsNotNull(objDetail)) {
      try {
        setDisableActionButton(true)
        let b = {
          p1: objDetail.l_id,
          p2: responseNotes,
          p3: objDetail.l_versioning
        }
        await notifBeforeAct({ title: 'Apakah Anda yakin menyetujui permintaan ini?', subTitle: 'Anda tidak bisa mengubah kembali.' })
          .then(async rc => {
            if (rc) {
              await LeaveController.approveLeaveRequest(b).then(x => {
                checkApproveResult({ x: x, funcSuccess: approveSuccess })
              })
            }
          })
      } catch (error) {
        enqueueSnackbar('Approve Request Failed', { variant: "error", autoHideDuration: 2000 })
      } finally {
        setDisableActionButton(false)
      }
    }
  }

  async function Reject(e) {
    if (IsNotNull(objDetail)) {
      try {
        setDisableActionButton(true)
        let b = {
          p1: objDetail.l_id,
          p2: responseNotes,
          p3: objDetail.l_versioning
        }
        await notifBeforeAct({ title: 'Apakah Anda yakin menolak permintaan ini?', subTitle: 'Anda tidak bisa mengubah kembali.' })
          .then(async rc => {
            if (rc) {
              await LeaveController.rejectLeaveRequest(b).then(x => {
                checkRejectResult({ x: x, funcSuccess: rejectSuccess })
              })
            }
          })
      } catch (error) {
        enqueueSnackbar('Reject Request Failed', { variant: "error", autoHideDuration: 2000 })
      } finally {
        setDisableActionButton(false)
      }
    }
  }

  async function getLeaveTypeData() {
    let a = []
    await LeaveController.getLeaveTypeForOptions().then(x => {
      if (IsNotNull(x)) {
        x.map(t => {
          a.push({ id: t.lt_id, value: t.lt_name })
        })
      }
    })
    setLeaveTypeData(a)
  }

  function getLeaveRequestTypeValue(x) {
    let rs = ''
    if (IsNotNull(x)) {
      let f = leaveTypeData.find(l => l.id === x)
      if (IsNotNull(f)) {
        rs = f.value
      }
    }
    return rs;
  }

  async function openURL(e, x) {
    try {
      if (IsNotNull(x.url)) {
        let b = {
          bucket: x.bucket,
          key: x.key
        }
        const rs = await getBlobS3(b)
        if (IsNotNull(rs)) {
          openFileNewTab(rs, x.filename, x.type)
        }
      }
    } catch (error) {
      enqueueSnackbar(`Open URL Error`, { variant: "error" })
    }
  }

  const isPending = IsNotNull(objDetail) && objDetail.l_status === 1
  const hasFiles = IsNotNull(objDetail) && IsNotNull(objDetail.l_file_details) && objDetail.l_file_details.length > 0

  return (
    <Fragment>
      <div className={styles['modern-page']}>
        <div className={styles['modern-card']}>
          <div className={styles['modern-card-header']}>
            <div className={styles['modern-header-content']}>
              <div>
                <div className={styles['modern-card-label']}>Permohonan Cuti / Izin</div>
                <div className={styles['modern-employee-name']}>
                  {IsNotNull(objDetail) ? objDetail.e_name : '—'}
                </div>
                {IsNotNull(objDetail) && (IsNotNull(objDetail.j_name) || IsNotNull(objDetail.d_name)) && (
                  <div className={styles['modern-employee-meta']}>
                    {[objDetail.j_name, objDetail.d_name].filter(IsNotNull).join(' • ')}
                  </div>
                )}
              </div>
              {getStatusComponent()}
            </div>
          </div>
          <div className={styles['modern-card-body']}>
            <div className={styles['modern-body-layout']}>
              {IsNotNull(objDetail) && IsNotNull(objDetail.e_file_details) && IsNotNull(objDetail.e_file_details.url) && (
                <img
                  className={styles['modern-employee-avatar']}
                  src={objDetail.e_file_details.url}
                  alt={objDetail.e_name}
                />
              )}
              <div className={styles['modern-body-details']}>
            <div className={styles['modern-info-row']}>
              <span className={styles['modern-info-label']}>Tipe</span>
              <span className={styles['modern-info-value']}>
                {IsNotNull(objDetail) ? getLeaveRequestTypeValue(objDetail.l_type) : '—'}
              </span>
            </div>

            <div className={styles['modern-info-row']}>
              <span className={styles['modern-info-label']}>Tanggal</span>
              <span className={styles['modern-info-value']}>
                {IsNotNull(objDetail)
                  ? objDetail.l_date.map(date => dayjs(date).format('DD MMM YYYY')).join(', ')
                  : '—'}
              </span>
            </div>
            <div className={styles['modern-info-row']}>
              <span className={styles['modern-info-label']}>
                {`Total Cuti/Izin ${IsNotNull(objDetail) ? dayjs(objDetail.l_created).format('YYYY') : dayjs().format('YYYY')}`}
              </span>
              <span className={styles['modern-info-value']}>
                <div className={styles['modern-total-container']}>
                  <span>{IsNotNull(objDetail) ? objDetail.total_days_request_in_year : '—'}</span>
                  <Tippy content="Lihat histori cuti/izin" placement="bottom">
                    <button type="button" className={styles['modern-hist-btn']} onClick={toogleDetail}>
                      <ClockHistory size={9} style={{ marginRight: 4 }} />
                      Histori
                    </button>
                  </Tippy>
                </div>
              </span>
            </div>

            <div className={styles['modern-info-row']}>
              <span className={styles['modern-info-label']}>Total Pengajuan</span>
              <span className={styles['modern-info-value']}>
                {IsNotNull(objDetail) ? `${objDetail.total_days}` : '—'}
              </span>
            </div>

            {IsNotNull(objDetail) && objDetail.l_duration_type === 2 && (
              <>
                <div className={styles['modern-info-row']}>
                  <span className={styles['modern-info-label']}>Dari Jam</span>
                  <span className={styles['modern-info-value']}>{objDetail.l_start_time}</span>
                </div>
                <div className={styles['modern-info-row']}>
                  <span className={styles['modern-info-label']}>Sampai Jam</span>
                  <span className={styles['modern-info-value']}>{objDetail.l_end_time}</span>
                </div>
              </>
            )}

            <div className={styles['modern-info-row']}>
              <span className={styles['modern-info-label']}>Catatan Pemohon</span>
              <span className={styles['modern-info-value']}>
                {IsNotNull(objDetail) ? (objDetail.l_descriptions || '—') : '—'}
              </span>
            </div>

            {IsNotNull(objDetail) && objDetail.l_status !== 1 && (
              <div className={styles['modern-info-row']}>
                <span className={styles['modern-info-label']}>Catatan Respon</span>
                <span className={styles['modern-info-value']}>
                  {objDetail.l_response_notes || '—'}
                </span>
              </div>
            )}

            {hasFiles && (
              <div className={styles['modern-info-row']}>
                <span className={styles['modern-info-label']}>
                  <Paperclip size={11} style={{ marginRight: 4 }} />
                  Lampiran
                </span>
                <div className={`${styles['modern-info-value']} ${styles['modern-files-list']}`}>
                  {objDetail.l_file_details.map((x, i) => (
                    <div key={i} className={styles['modern-file-item']} onClick={(e) => openURL(e, x)}>
                      <EyeFill className={styles['modern-file-icon']} />
                      <span>{x.filename}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {isPending && (
              <div className={styles['modern-response-section']}>
                <div className={styles['modern-response-label']}>Catatan Respon Anda</div>
                <textarea
                  className={styles['modern-textarea']}
                  rows={4}
                  maxLength={200}
                  placeholder="Tulis catatan respon (opsional)..."
                  onChange={e => setResponseNotes(e.target.value)}
                  value={responseNotes}
                />
              </div>
            )}
              </div>
            </div>
          </div>
          {isPending && (
            <div className={styles['modern-card-footer']}>
              <button
                className={`${styles['modern-btn']} ${styles['modern-btn-approve']}`}
                disabled={disableActionButton}
                onClick={e => Approve(e)}
              >
                <CheckCircleFill size={13} />
                Setujui
              </button>
              <button
                className={`${styles['modern-btn']} ${styles['modern-btn-reject']}`}
                disabled={disableActionButton}
                onClick={e => Reject(e)}
              >
                <XCircleFill size={13} />
                Tolak
              </button>
            </div>
          )}

        </div>
      </div>

      {modalDetail && (
        <ModalDetail
          modal1={modalDetail}
          toggleHandler={toogleDetail}
          ObjDetail={objDetail}
        />
      )}
    </Fragment>
  );
}

export default CFLDashboard;